import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Timer, AlertCircle } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 9
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <section className="py-12 bg-charcoal text-white border-y-4 border-amber" data-id="element-60">
      <div className="container mx-auto px-4" data-id="element-61">
        <div className="max-w-4xl mx-auto text-center" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="flex items-center justify-center mb-4 text-amber" data-id="element-63">
            <Timer className="w-6 h-6 mr-2 animate-pulse" data-id="element-64" />
            <h2 className="text-xl md:text-2xl font-bold uppercase tracking-wider" data-id="element-65">
              El precio de lanzamiento termina en:
            </h2>
          </motion.div>

          <div className="flex justify-center gap-4 md:gap-8 mb-6" data-id="element-66">
            <div className="flex flex-col items-center" data-id="element-67">
              <div className="bg-wood-dark w-20 h-24 md:w-24 md:h-28 rounded-lg flex items-center justify-center text-4xl md:text-6xl font-black text-amber shadow-inner border border-wood-light/20" data-id="element-68">
                {formatNumber(timeLeft.hours)}
              </div>
              <span className="text-xs md:text-sm mt-2 text-cream/60 uppercase tracking-widest" data-id="element-69">
                Horas
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-amber/50 self-start mt-4" data-id="element-70">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-71">
              <div className="bg-wood-dark w-20 h-24 md:w-24 md:h-28 rounded-lg flex items-center justify-center text-4xl md:text-6xl font-black text-amber shadow-inner border border-wood-light/20" data-id="element-72">
                {formatNumber(timeLeft.minutes)}
              </div>
              <span className="text-xs md:text-sm mt-2 text-cream/60 uppercase tracking-widest" data-id="element-73">
                Min
              </span>
            </div>
            <div className="text-4xl md:text-6xl font-black text-amber/50 self-start mt-4" data-id="element-74">
              :
            </div>
            <div className="flex flex-col items-center" data-id="element-75">
              <div className="bg-wood-dark w-20 h-24 md:w-24 md:h-28 rounded-lg flex items-center justify-center text-4xl md:text-6xl font-black text-amber shadow-inner border border-wood-light/20" data-id="element-76">
                {formatNumber(timeLeft.seconds)}
              </div>
              <span className="text-xs md:text-sm mt-2 text-cream/60 uppercase tracking-widest" data-id="element-77">
                Seg
              </span>
            </div>
          </div>

          <p className="text-cream/80 italic mb-8" data-id="element-78">
            *Después sube $8.000 ARS y no vuelve a bajar.*
          </p>

          <div className="max-w-md mx-auto bg-wood-dark/50 p-4 rounded-xl border border-wood-light/10" data-id="element-79">
            <div className="flex justify-between text-sm mb-2 font-medium" data-id="element-80">
              <span className="text-cream" data-id="element-81">Cupos al precio de lanzamiento</span>
              <span className="text-amber" data-id="element-82">60% tomados</span>
            </div>
            <div className="w-full bg-charcoal rounded-full h-3 overflow-hidden" data-id="element-83">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '60%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-amber h-full rounded-full relative" data-id="element-84">
                <div className="absolute inset-0 bg-white/20 w-full h-full animate-pulse" data-id="element-85"></div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}